module.exports = __webpack_public_path__ + "static/media/like-hover-button.794a2cd7.svg";